import React from "react";

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import FileUpload from "./views/UploadView/UploadView";
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';

// to change font style for all element we should provide theme
// now it is default
const THEME = createMuiTheme({
   typography: {
    "fontFamily": `"Girlous", "Roboto", "Helvetica", "Arial", sans-serif`,
    "fontSize": 14,
    "fontWeightLight": 300,
    "fontWeightRegular": 400,
    "fontWeightMedium": 500
   }
});

function App() {
  return (
    <ThemeProvider theme={THEME}>
    <Router>
      <Switch>
        <Route path="/">
          <FileUpload />
        </Route>

      </Switch>
    </Router>
  </ThemeProvider>
  );
}

export default App;
